<button class="flex justify-center items-center menu-button mat-body-1 m-0 fw-700 fs-16 mat-subtitle-2 m-0" [matMenuTriggerFor]="userMenu">
  <div *ngIf="principalAbbreviation">{{principalAbbreviation}}</div>
</button>

<mat-menu #userMenu="matMenu" xPosition="before" class="p-12 menu-unlimited-width menu-no-padding">
  <div class="full-name ta-center mat-body-1 m-0 primary-fg">
    {{principal?.attributes?.given_name}} {{principal?.attributes?.family_name}}
  </div>
  <div class="ta-center email neutral-4-fg ml-20 mr-20 fw-400 mat-body-1">
    {{principal?.attributes?.email}}
  </div>
  <mat-divider class="neutral-blue-6 mt-12 mb-12"></mat-divider>
  <div *ngIf="authorizedUser" class="flex items-center menu-item menu-settings mat-body-1 primary-fg"
    [routerLink]="['/', tenant, RouterSegments.SETTINGS]">
    <mat-icon svgIcon="settings" class="icon-sm mr-8"></mat-icon>
    {{ 'USER_MENU.SETTINGS' | transloco }}
  </div>
  <div class="flex items-center menu-item menu-logout warn-solid-fg mat-body-1 m-0" (click)="logout()">
    <mat-icon svgIcon="logout" class="icon-sm mr-8"></mat-icon>
    {{ 'USER_MENU.LOGOUT' | transloco }}
  </div>
</mat-menu>
